export default __webpack_public_path__ + "static/media/MercadoLibre.751aa8a1.png";